import React from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import ModalResumen from "./ModalResumen";
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha, getFechaActual } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";

function ModalRemisiones(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    const [remitidoA, setRemitidoA] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(getFechaActual());
    const [fechaHora, setFechaHora] = useState('');
    const [remitidoPor, setRemitidoPor] = useState();

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado
    const [remisionSeleccionada, setRemisionSeleccionada] = useState(null); // 🆕 Para guardar la última remisión

    const [listaProfesionales, setListaProfesionales] = useState([]);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/profesionales-atencion-pacientes', config)
            .then(response => {
                if (response.status === 200) {
                    setListaProfesionales(response.data);
                }
            })
            .catch(error => console.log(error.response.data))

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/remisiones', config2)
            .then(response => {
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    let segundoNombrePaciente = item.segundo_nombre ? item.segundo_nombre + " " : "";
                    let nombrePaciente = item.primer_nombre + " " + segundoNombrePaciente + item.primer_apellido + " " + item.segundo_apellido;

                    // 🎨 USAR EL MISMO FORMATO QUE LA VISTA INDIVIDUAL - Tablas con bandas grises

                    // 1. Tabla de información del paciente y fecha
                    let segmentoInfo = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.tipo_documento + ' ' + item.numero_documento}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de datos de la remisión
                    let segmentoDatos = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.remitido_a}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.especialidad || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.direccion || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.telefono || 'No especificado'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 3. Tabla de profesional remitente (Invertido: ahora va antes de la descripción)
                    let segmentoRemitente = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA</td>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                            <img src="${item.firma}" style="max-width: 180px; max-height: 70px; display: block;" />
                                            <div style="margin-top: 4px; font-size: 11px; color: #666;">
                                                RM: ${item.registro_medico || ''} | Cód. Hab: ${item.codigo_habilitacion || ''}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 4. Tabla de descripción (Ahora va de última)
                    let segmentoDescripcion = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE REMISIÓN</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.descripcion}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    const itemParcial = segmentoInfo + segmentoDatos + segmentoRemitente + segmentoDescripcion + "<hr style='border-top: 2px solid #e0e0e0; margin: 25px 0;'>";

                    consolidadoItems += itemParcial;
                    return null;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            });
    }




    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // 🔧 Extraer fecha del campo fechaHora para backend
        let fechaSolo = fecha; // Fallback al valor por defecto
        if (fechaHora) {
            // Extraer solo la fecha (YYYY-MM-DD) del datetime-local
            fechaSolo = fechaHora.split('T')[0];
        }

        const data = {
            paciente_id: pacienteId,
            remitido_por: nombreProfesional,
            firma: firmaimg,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            remitido_a: remitidoA,
            direccion: direccion,
            telefono: telefono,
            especialidad: especialidad,
            descripcion: descripcion,
            user_id: userdata.user_id, // 🔧 Agregar user_id requerido
            fecha: fechaSolo, // 🔧 Fecha extraída de fechaHora
            hora_inicial: fechaHora
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        axios.post('remision', data, config)
            .then(response => {
                setLoading(false);
                setDeshabilitarBotonGuardar(true);
                props.guardarCambios('La remisión ha sido agregada');
                cargaritems();
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando remisión:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })

    }


    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setRemisionSeleccionada(resumenIndividual); // 🆕 Guardar remisión seleccionada para imprimir

        const segundoNombre = resumenIndividual.segundo_nombre ? resumenIndividual.segundo_nombre : "";
        const segundoApellido = resumenIndividual.segundoApellido ? resumenIndividual.segundo_apellido : "";

        const nombrePaciente = resumenIndividual.primer_nombre + " " + segundoNombre + " " + resumenIndividual.primer_apellido + " " + segundoApellido;

        // 🎨 Nuevo estilo con tablas y bandas grises (igual que ModalFormulas.js)
        const contenidoResumen = `
            <div style="font-family: Arial, sans-serif;">
                
                <!-- Banner: REMISIÓN MÉDICA -->
                <div style="margin-bottom: 12px;">
                    <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                        REMISIÓN MÉDICA
                    </div>
                </div>

                <!-- Información del Paciente -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.fecha}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.tipo_documento + ' ' + resumenIndividual.numero_documento}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Datos de la Remisión -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.remitido_a}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.especialidad || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.direccion || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.telefono || 'No especificado'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Profesional que Remite (Invertido: ahora antes de la descripción) -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${resumenIndividual.profesional}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.registro_medico}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO HABILITACIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.codigo_habilitacion}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Descripción (Invertido: ahora después del profesional) -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE REMISIÓN</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                    ${resumenIndividual.descripcion}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>`;

        setContenidoResumenIndividual(contenidoResumen);
        setShowModalResumen(true);
    }


    useEffect(() => {
        cargaritems();

        // Cleanup function to prevent memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
        };
    }, [props.cargarHistorial]);



    const handleProfesionalRemision = (profesionalRemision) => {

        for (let prof of listaProfesionales) {
            if (profesionalRemision == prof.id) {
                setNombreProfesional(prof.name + ' ' + prof.lastname);
                setRegistroMedico(prof.registro_medico);
                setCodigoHabilitacion(prof.codigo_habilitacion);
                setFirmaimg(prof.firma_blob);
                break;
            }
        }

    }


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `remisiones - consolidado - ${props.docPaciente || 'paciente'}.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // 🆕 Usar encabezado personalizado si está disponible, eliminar información duplicada del paciente
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // 🔧 ELIMINADA información duplicada del paciente (anamnesis) como en ModalEvolucion.js
        let remisionCompleta = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            '<h1 style="text-align: center; margin-bottom: 20px;">REMISIONES</h1>' +
            consolidado +
            '</div>';

        // Generar PDF con foliación
        html2pdf().from(remisionCompleta).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            pdf.save(opt.filename);
        });
    }

    // 🆕 Función para imprimir remisión individual (igual que ModalFormulas.js)
    const imprimirRemision = () => {
        if (!remisionSeleccionada) {
            alert('No hay remisión seleccionada para imprimir');
            return;
        }

        console.log('Imprimiendo remisión:', remisionSeleccionada);

        var opt = {
            margin: 10,
            filename: 'remision-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const segundoNombre = remisionSeleccionada.segundo_nombre ? remisionSeleccionada.segundo_nombre : "";
        const segundoApellido = remisionSeleccionada.segundo_apellido ? remisionSeleccionada.segundo_apellido : "";
        const nombreCompleto = remisionSeleccionada.primer_nombre + " " + segundoNombre + " " + remisionSeleccionada.primer_apellido + " " + segundoApellido;
        const documentoCompleto = remisionSeleccionada.tipo_documento + ' - ' + remisionSeleccionada.numero_documento;

        // 2. BANNER: REMISIÓN MÉDICA
        let banner = `
        <div style="margin-bottom: 8px;">
            <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                REMISIÓN MÉDICA
            </div>
        </div>`;

        // 3. Información del Paciente y Fecha
        let tablaInfoPaciente = `
        <div style="margin-bottom: 8px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                <tbody>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.fecha}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PACIENTE</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                    </tr>
                </tbody>
            </table>
        </div>`;

        // 4. Datos de la Remisión
        let tablaDatosRemision = `
        <div style="margin-bottom: 8px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                <tbody>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 25%; border: 1px solid #dee2e6;">REMITIDO A</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.remitido_a}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.especialidad || 'No especificada'}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.direccion || 'No especificada'}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">TELÉFONO</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.telefono || 'No especificado'}</td>
                    </tr>
                </tbody>
            </table>
        </div>`;

        // 5. Profesional que Remite (Invertido: ahora antes de la descripción)
        let tablaProfesional = `
        <div style="margin-top: 12px; page-break-inside: avoid;">
            <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                <tbody>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${remisionSeleccionada.profesional}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.registro_medico}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">CÓDIGO HABILITACIÓN</td>
                        <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${remisionSeleccionada.codigo_habilitacion}</td>
                    </tr>
                </tbody>
            </table>
        </div>`;

        // 6. Descripción (Invertido: ahora después de profesional)
        let tablaDescripcion = `
        <div style="margin-bottom: 8px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                <tbody>
                    <tr>
                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE REMISIÓN</td>
                    </tr>
                    <tr>
                        <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                            ${remisionSeleccionada.descripcion || 'Sin descripción'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>`;

        // Unir todo el contenido (Invertido tablaDescripcion y tablaProfesional)
        let contenidoImpresion = encabezadoHTML + banner + tablaInfoPaciente + tablaDatosRemision + tablaProfesional + tablaDescripcion;

        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages,
                    pdf.internal.pageSize.getWidth() / 2,
                    pdf.internal.pageSize.getHeight() - 5,
                    { align: 'center' });
            }

            // ✅ MÉTODO PRINCIPAL: Nueva pestaña
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => {
                        printWindow.print();
                    }, 500);
                };
            } else {
                // ✅ FALLBACK: iframe posicionado
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Por favor, descarga el PDF.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        }).catch(error => {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        });
    }


    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="remision">

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha y Hora *</label>
                                                    <div className="input-group">
                                                        <input 
                                                            type="datetime-local" 
                                                            className="form-control" 
                                                            value={fechaHora} 
                                                            onChange={(e) => setFechaHora(e.target.value)}
                                                            required
                                                        />
                                                        <div className="input-group-append">
                                                            <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                                                const ahora = new Date();
                                                                setFechaHora(ahora.toISOString().slice(0, 16));
                                                            }}>
                                                                <i className="fas fa-clock"></i> Actual
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {errorlist.fecha && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.fecha}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoPor">Remitido por *</label>
                                                    <select name="remitidoPor" className="form-control" id="remitidoPor" onChange={(e) => handleProfesionalRemision(e.target.value)} required>
                                                        <option value="">Seleccione profesional...</option>
                                                        {
                                                            listaProfesionales.map((prof) =>
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            )
                                                        }
                                                    </select>
                                                    {errorlist.remitido_por && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_por}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoA">Remitido a *</label>
                                                    <input type="text" name="remitido-a" className="form-control" id="remitidoA" onChange={(e) => setRemitidoA(e.target.value)} required />
                                                    {errorlist.remitido_a && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_a}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input type="text" name="telefono" className="form-control" id="telefono" onChange={(e) => setTelefono(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input type="text" name="direccion" className="form-control" id="direccion" onChange={(e) => setDireccion(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="especialidad">Especialidad</label>
                                                    <input type="text" name="especialidad" className="form-control" id="especialidad" onChange={(e) => setEspecialidad(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="descripcion">Descripción</label>
                                                    <textarea
                                                        name="descripcion"
                                                        className="form-control"
                                                        id="descripcion"
                                                        rows="4"
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Ingrese la descripción de la remisión..."
                                                    />
                                                    {errorlist.descripcion && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.descripcion}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-primary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <a href="#" className="btn btn-primary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</a>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">

                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Remisiones</b>

                                    {
                                        historial.map((item) =>

                                            <div key={item.id} className="timeline-item-container" onClick={() => verResumen('Remisión', item)}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>
                                {/*<br />
                                        <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>*/}

                            </div>
                        </div>

                    </div>
                </section>



                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenRemisiones"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        profesional={profesionalResumenIndividual}
                        registro={registroMedicoResumenIndividual}
                        codigo={codigoHabilitacionResumenIndividual}
                        firma={firmaResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'remision'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        onClose={() => setShowModalResumen(false)}
                        imprimirFuncion={imprimirRemision} // 🆕 Pasar función de impresión
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoRemisiones"
                        titulo="Resumen Remisiones"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'historico-remisiones'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        onClose={() => setShowModalConsolidado(false)}
                    />
                )}

            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalRemisiones;